import request from '@/utils/request'

/**
 * 获取映射域名列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function listMappingDomain(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mapping.listMappingDomain',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存映射域名
 * @param {Object} data 映射域名数据
 * @returns {Promise} 返回Promise对象
 */
export function saveMappingDomain(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mapping.saveMappingDomain',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新映射域名
 * @param {Object} data 映射域名数据
 * @returns {Promise} 返回Promise对象
 */
export function updateMappingDomain(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mapping.updateMappingDomain',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除映射域名
 * @param {Object} data 映射域名数据
 * @returns {Promise} 返回Promise对象
 */
export function deleteMappingDomain(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mapping.deleteMappingDomain',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}